import { Col, Form, Row } from 'antd';
import { FormField } from 'components';
import { get, omit, isNil } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateFormField, getOtp } from 'store/forms/actions';
import { formFields111, formFields112 } from './formFields';
import { getTaxisDataByTk, getTaxisDataByAbiTK } from 'store/user/actions';
import moment from 'moment';
import { useForm } from 'antd/lib/form/Form';
import { isBeneficiary, formattedNumber } from 'utils';
import { OtpModal } from 'components/layout/components';
import Sorefsis from 'components/sorefsis';
import SorefsisChart from '../sorefsisChart';
import BusinessSizeCalculator from 'components/businessSizeCalculator';
import BusinessSizeField from 'components/businessSizeField';
import {
  taxisUserData,
  taxisUserData1,
  taxisUserData2,
  taxisUserDataUAT,
} from 'utils/taxisUser';
import styles from './SubTab1.module.scss';

const SubTab1 = () => {
  const dispatch = useDispatch();
  const user = useSelector(state => state.user);
  const carrier = useSelector(state => state.forms.carrier);
  const task = useSelector(state => state.forms.task);
  const isViewMode = useSelector(state => state.forms.carrier.viewMode);
  const viewMode = isViewMode || !isBeneficiary(user.groups);
  const [otpModalOpen, setOptModalOpen] = useState(false);
  const [otpValidateParams, setOtpValidateParams] = useState({});
  const [cancelOtp, setCancelOtp] = useState('');
  const [form] = useForm();
  const taxisUserDummyData = taxisUserData;
  const totalAmountSorefsis = useSelector(
    state => state.forms.carrier?.totalAmountSorefsis
  );

  useEffect(() => {
    if (carrier?.abiTk === '00000' || carrier?.abiTk === '') {
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'abiTk',
          value: null,
        })
      );
    }
  }, [carrier.abiTk]);

  const handleChange = ({ key, type, event }) => {
    let newValue;

    if (type === 'text' || type === 'textarea' || type === 'radio') {
      newValue = event.target.value;
    } else if (type === 'date') {
      newValue = new Date(event).toLocaleDateString('en-US');
    } else if (type === 'checkbox') {
      newValue = event.target.checked;
    } else if (type === 'businessSize') {
      newValue = typeof event === 'string' ? event : event.event || event;
    } else if (
      type === 'select' ||
      type === 'number' ||
      type === 'numberWithDecimals'
    ) {
      newValue = event;
    }

    dispatch(
      updateFormField({
        group: 'carrier',
        key,
        value: newValue,
      })
    );

    if (key === 'legalEmail' && carrier?.legalEmailValidated) {
      dispatch(
        updateFormField({
          group: 'carrier',
          key: key + 'Validated',
          value: false,
        })
      );
    }
  };

  useEffect(() => {
    if (user?.taxis_data) {
      const onomasia = user?.taxis_data?.onomasia?.split(',');
      // setTkOptions(user.taxis_data?.tks?.map(item => ({
      //   label: item.code,
      //   value: item.code,
      // })))
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'legalSurname',
          value: !isNil(user.taxis_data?.onomasia)
            ? onomasia[0] + ' ' + onomasia[1]
            : carrier.legalSurname,
        })
      );
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'legalName',
          value: !isNil(user.taxis_data?.onomasia)
            ? onomasia[2]
            : carrier.legalName,
        })
      );
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'legalFather',
          value: !isNil(user.taxis_data?.onomasia)
            ? onomasia[3]
            : carrier.legalFather,
        })
      );
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'legalVat',
          value: !isNil(user.taxis_data?.afmTrimmed)
            ? user.taxis_data?.afmTrimmed
            : carrier.legalVat,
        })
      );
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'abiStreet',
          value:
            !isNil(user.taxis_data?.residenceAddress) &&
            !isNil(user.taxis_data?.residenceAddressNo)
              ? user.taxis_data?.residenceAddress +
                ' ' +
                user.taxis_data?.residenceAddressNo
              : carrier.abiStreet,
        })
      );
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'abiTk',
          value: carrier?.abiTk,
          // !isNil(user.taxis_data?.tks)
          // ? user.taxis_data?.tks?.map(item => ({
          //   label: item.code,
          //   value: item.code,
          // }))
          // : carrier.abiTk,
        })
      );
    }
  }, [user?.taxis_data]);

  useEffect(() => {
    if (user.userId === 'taxisUser') {
      Object.entries(taxisUserData).forEach(([key, value]) => {
        dispatch(
          updateFormField({
            group: 'carrier',
            key,
            value,
          })
        );
      });
    } else if (
      user.userId === 'taxisUser1' ||
      user?.userId === 'UAT_TaxisUser2'
    ) {
      Object.entries(taxisUserData1).forEach(([key, value]) => {
        dispatch(
          updateFormField({
            group: 'carrier',
            key,
            value,
          })
        );
      });
    } else if (user.userId === 'taxisUser2') {
      Object.entries(taxisUserData2).forEach(([key, value]) => {
        dispatch(
          updateFormField({
            group: 'carrier',
            key,
            value,
          })
        );
      });
    } else if (user.userId === 'UAT_TasisUser') {
      Object.entries(taxisUserDataUAT).forEach(([key, value]) => {
        dispatch(
          updateFormField({
            group: 'carrier',
            key,
            value,
          })
        );
      });
    }
  }, [user]);

  useEffect(() => {
    if (isNil(carrier?.abiTk)) {
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'abiTk',
          value: !isNil(user.taxis_data?.residenceZipCode)
            ? user.taxis_data?.residenceZipCode
            : carrier.abiTk,
        })
      );
    }
  }, [user.taxis_data]);

  useEffect(() => {
    if (cancelOtp === 'legalEmail') {
      dispatch(
        updateFormField({
          group: 'carrier',
          key: cancelOtp + 'Validated',
          value: false,
        })
      );
    }
  }, [cancelOtp]);

  const renderFieldValue = field => {
    const value = get(carrier, field.name, '');
    return field.type === 'date' ? (value ? moment(value) : '') : value;
  };

  useEffect(() => {
    form.setFieldsValue({
      abiGcrCode: carrier?.abiGcrCode,
      companyName: carrier?.companyName,
      companyLegalType: carrier?.companyLegalType,
      buildStreet: carrier?.buildStreet,
      buildTk: carrier?.buildTk,
      legalVat: carrier?.legalVat,
      abiDistrict: carrier?.abiDistrict,
      legalPhoneMobile: carrier?.legalPhoneMobile,
      legalEmail: carrier?.legalEmail,
      businessSize: carrier?.businessSize,
    });

    if (carrier.abiGcrCode) form.validateFields(['abiGcrCode']);
    if (carrier.legalPhoneMobile) form.validateFields(['legalPhoneMobile']);
    if (carrier.legalEmail) form.validateFields(['legalEmail']);
  }, [form, carrier]);

  const verifyOtp = fieldName => {
    const params = {
      processInstanceId: task.processInstanceId,
      fieldName: fieldName === 'legalPhoneMobile' ? 'mobile' : 'email',
      fieldValue: carrier?.[fieldName],
      field: fieldName,
    };
    setOtpValidateParams(params);
    if (carrier?.[fieldName]) {
      dispatch(getOtp(params));
      setOptModalOpen(true);
    }
  };

  return (
    <div className={styles.subTab1BasicInfo} style={{ minHeight: 800 }}>
      <OtpModal
        isVisible={otpModalOpen}
        setVisible={setOptModalOpen}
        otpValidateParams={otpValidateParams}
        cancelOtp={cancelOtp}
        setCancelOtp={setCancelOtp}
      />
      <Form
        form={form}
        initialValues={{
          ...carrier,
        }}
        trigger="onChange"
        className={styles.basicInfoForm}
      >
        <div
          className="carrier-data-form"
          style={{ width: '45%', display: 'inline-block' }}
        >
          <p className="mt-6 mr-0 color-purple-3 text-bold font-size-24">
            Στοιχεία Φορέα Επένδυσης
          </p>
          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            className="carrier-data-form__row"
            align="top"
          >
            {formFields111.map((field, index) => {
              return (
                <Col key={index} className="gutter-row" span={field.span}>
                  <Form.Item
                    name={[field.name]}
                    rules={field.rules}
                    value={renderFieldValue(field)}
                    validateFirst
                  >
                    <FormField
                      key={index}
                      disabled={field?.disabled ?? viewMode}
                      label={
                        <span>
                          {field.label}
                          <span className="color-asterisk">{' *'}</span>
                        </span>
                      }
                      {...omit(field, [
                        'span',
                        'rules',
                        'offset',
                        'disabled',
                        'label',
                        'asterisk',
                      ])}
                      onChange={value =>
                        handleChange({
                          key: field.name,
                          type: field.type,
                          event: value,
                        })
                      }
                    />
                  </Form.Item>
                </Col>
              );
            })}
          </Row>
        </div>
        <div
          className="carrier-data-form move-up"
          style={{ width: '45%', display: 'inline-block', marginLeft: '10%' }}
        >
          <p className="mt-6 mr-0 color-purple-3 text-bold font-size-24">
            Διεύθυνση Έδρας Επιχείρησης
          </p>
          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            className="carrier-data-form__row"
          >
            {formFields112(carrier?.ownerStatus).map((field, index) => {
              return (
                <Col key={index} className="gutter-row" span={field.span}>
                  <Form.Item
                    name={[field.name]}
                    rules={
                      field.name === 'buildLegalVat'
                        ? [
                            ...field.rules,
                            {
                              required: true,
                              message: 'Το πεδίο είναι υποχρεωτικό',
                            },
                          ]
                        : field.rules
                    }
                    validateFirst
                    value={renderFieldValue(field)}
                  >
                    <FormField
                      key={index}
                      disabled={field?.disabled ?? viewMode}
                      {...omit(field, ['span', 'rules', 'disabled'])}
                      options={
                        field.name === 'buildPerfectureBuilding'
                          ? carrier.buildPerfectureBuildingOptions &&
                            carrier.buildPerfectureBuildingOptions.map(b => ({
                              value: b.value,
                            }))
                          : field.name === 'abiDistrictBuilding'
                          ? carrier.abiDistrictBuildingOptions &&
                            carrier.abiDistrictBuildingOptions.map(b => ({
                              value: b.value,
                            }))
                          : field.options
                      }
                      onChange={value =>
                        handleChange({
                          key: field.name,
                          type: field.type,
                          event: value,
                        })
                      }
                    />
                  </Form.Item>
                </Col>
              );
            })}
          </Row>
        </div>
        {/* <Row
          gutter={{ xs: 0, sm: 2, md: 5, lg: 10 }}
          className="carrier-data-form__row mt-6 sorefsis"
        >
          <Col span={20} className="sorefsis-col-">
            <>
              <Sorefsis></Sorefsis>
            </>
          </Col>
          <Col span={4} className="sorefsis-col-2">
            <div className="mt-1">
              <SorefsisChart
                realValue={totalAmountSorefsis ? totalAmountSorefsis : 0}
                limit={process.env.REACT_APP_SOREFSIS_AMOUNT}
              />
            </div>
            <div>
              {!viewMode &&
                totalAmountSorefsis > process.env.REACT_APP_SOREFSIS_AMOUNT && (
                  <div
                    role="alert"
                    className="ant-form-item-explain-error mt-0 mb-2"
                  >
                    Το Σύνολο Σώρευσης έχει υπερβεί το Όριο Deminimis κατά{' '}
                    {formattedNumber(
                      totalAmountSorefsis -
                        process.env.REACT_APP_SOREFSIS_AMOUNT
                    )}
                    €
                  </div>
                )}
            </div>
          </Col>
        </Row> */}
      </Form>
    </div>
  );
};

export default SubTab1;
